<template>
  <div class="s-playing-now__options__filters">
    <AgnosticFilter
      v-for="(filter, index) in showFilters"
      :key="filter"
      :placeholder="placeholders[index]"
      :value="selectedFilters[filter]"
      :filter="filters[filter]"
      :filter-name="filter"
      @changed="updateSelectedFilters"></AgnosticFilter>
  </div>
</template>

<script>
import AgnosticFilter from './AgnosticFilter.vue'

export default {
  components: {
    AgnosticFilter,
  },
  props: {
    filters: {
      default() {
        return {}
      },
      type: Object,
    },
    selectedFilters: {
      default() {
        return {}
      },
      type: Object,
    },
    showFilters: {
      default() {
        return []
      },
      type: Array,
    },
    placeholders: {
      default() {
        return []
      },
      type: Array,
    },
  },
  emits: ['filterChanged'],
  data() {
    return {
      modelFilters: { ...this.selectedFilters },
    }
  },
  methods: {
    updateSelectedFilters(val, key) {
      this.modelFilters[key] = val
      this.$nextTick(() => {
        this.$emit('filterChanged', this.modelFilters, key)
      })
    },
  },
}
</script>
